import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MODE = () => {
  return (
    <CardSection id="MODE" title="MODE">
      <Paragraph>숫자 집합에서 가장 자주 발생하는 값을 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MODE(VALUE_1, VALUE_2, [VALUE_3, ...])</Paragraph>
        <Ul>
          <Li>
            <b>VALUE_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_2</b>은 두 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_3, ... [선택 사항]</b>은 추가 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeMode" /> */}
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 숫자 값, 숫자 값이 포함된 열 또는 숫자 값을
          반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          여러 숫자가 1보다 큰 동일한 발생 횟수를 가지고 있는 경우, 반환되는
          값은 세트에서 처음 나타나는 숫자입니다(왼쪽에서 오른쪽으로 읽음).
          숫자가 두 번 이상 나타나지 않으면 함수는 오류를 반환합니다.
        </Paragraph>
        <Paragraph>
          <b>MODE</b>와 관련된 가장 일반적인 문제는 제공된 숫자 집합에 중복이
          없는 경우입니다. 함수가 성공적으로 평가되려면 적어도 하나의 숫자가 두
          번 이상 나타나야 합니다. 최소 인수 수(2)를 사용하는 경우 각 인수는
          같은 숫자로 평가되어야 하며 그렇지 않으면 오류가 발생합니다. 변형이 더
          제한적인 더 큰 숫자 집합은 <b>MODE</b>가 오류를 반환할 가능성을
          줄입니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
